import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import "./styles.css";
import { Breadcrumb, CustomPopUpModal, PopUpModal, Title } from "../../Components/Atoms";
import PATHS from "../../Routes/paths";
import { getAlerts, saveRoute } from "../../APIs";
import { DEVICE_HWTYP_VALUES, GEOFENCE_TRIGGER_TYPE } from "../../Library/constants";
import { StoreContext } from "../../Library/contexts";
import { getLocalisedDate, getLocalisedTime } from "../../Library/datetime";
import { Button, Input } from "@chakra-ui/react";
import { ArrowRightIcon, CloseIcon, SuccessIcon } from "../../Assets/images/svgs";
import { ReactTable } from "../../Components/Molecules";
import { ALERT_VEHICLE_TABLE_HEADERS } from "../../Library/tableHeaders";
import { useNavigate } from "react-router-dom";

const SetRoutes = () => {
  const [ geofences, setGeofences ] = useState([]);
  const [ geofenceSeq, setGeofenceSeq ] = useState([]);
  const [ showGeofences, setShowGeofences ] = useState(false);
  const [ hoveredBox, setHoveredBox ] = useState(false);
  const [ error, setError ] = useState("");
  const [ showSuccessModal, setShowSuccessModal ] = useState(false);
  const [ routeTitle, setRouteTitle ] = useState("");

  const { userVehicles } = useContext(StoreContext);
  const userVehMap = useRef({});
  const selectedVids = useRef([]);
  const navigate = useNavigate();

  const breadcrumbPaths = [
    { idx: 1, name: "View Routes", link: PATHS.VIEW_ROUTES },
    { idx: 2, name: "Set route", isCurrentPage: true },
  ];

  useEffect(() => {
    userVehicles.forEach(veh => {
      userVehMap.current[veh.idx] = veh
    });
  }, [ userVehicles ]);

  useEffect(() => {
    getAlerts(GEOFENCE_TRIGGER_TYPE, (err, data) => {
      if(err) console.error("Error fetching geofence alerts", err);
      else {
        setGeofences(data);
      }
    });
  }, []);

  const getVehiclesForGeofence = (fence) => {
    if (fence && fence.vehIdArr && fence.vehIdArr.length) {
      let vehicles = fence.vehIdArr.map(vid => {
        let veh = userVehMap.current[vid];
        let vehicle = "";
        if (veh && (veh.mo || veh.reg)) {
          vehicle = (veh.mo || veh.reg);
        }

        return vehicle;
      });

      let vehs = vehicles.filter(val => val);
      if (vehs && vehs.length) return vehs.join(", ");
      else return "-";
    }
  }

  const handleGeofenceSelect = (fence, remove, index) => {
    if (remove) {
      const updatedGeofenceSeq = [...geofenceSeq];
      updatedGeofenceSeq.splice(index - 1, 1);
      setGeofenceSeq(updatedGeofenceSeq);
    } else {
      let fenceSequence = [ ...geofenceSeq ];
      if (fence && fence.idx) {
        fenceSequence.push(fence);
        setGeofenceSeq(fenceSequence);
      }
    }

    setError("");
  }

  const handleCrossIcon = (seqNo, isSelected, isRemove) => {
    if (isRemove) setHoveredBox(null);
    else if (isSelected) setHoveredBox(seqNo);
  }

  const renderGeofenceCard = (fence, className, isLastElem, sequenceNo) => {
    return (
      <>
        <div className={`geofence-box ${className}`} onClick={() => handleGeofenceSelect(fence, !!className, sequenceNo)} onMouseEnter={() => handleCrossIcon(sequenceNo, !!className)} onMouseLeave={() => handleCrossIcon(null, null, true)}>
          {className ? <p className="sequence-bubble">{(className && sequenceNo === hoveredBox) ? <CloseIcon className="selected-box-close-btn" /> : sequenceNo}</p> : ""}
          {className ? <p className="selected-title">{fence.title}</p> : <Title variant="md" fixed className="geofence-title">{fence.title}</Title>}
          {!className ? <div className="geofence-detail-box">
            <p>Created at: <span>{getLocalisedDate(fence.ts)}, {getLocalisedTime(fence.ts)}</span></p>
            <p>Region: <span>{fence.region || "N/A"}</span></p>
            <div className="vehicle-box">
              <p>Vehicles:</p>
              <span>{getVehiclesForGeofence(fence)}</span>
            </div>
          </div> : null}
        </div>
        {(className && !isLastElem) ? <ArrowRightIcon /> : null}
      </>
    )
  }

  const handleSaveRoute = () => {
    let data = {};

    if (routeTitle) {
      data.nm = routeTitle;
    } else return setError("Please enter title for this route.");

    if (geofenceSeq && geofenceSeq.length >= 2) {
      data.trgIds = geofenceSeq.map(fence => fence.idx);
    } else return setError("You must select at least two geofences to make a route.");

    if (selectedVids.current && selectedVids.current.length) {
      data.vids = selectedVids.current;
    } else return setError("Please select vehicles.");

    saveRoute(data, (err) => {
      if (err) {
       console.error(err);
       setError(err);
     } else {
        setShowSuccessModal({
          open: true,
          modalBody: (
            <div className="link-copy-success">
              <SuccessIcon />
              <p>Route saved successfully!</p>
            </div>
          ),
          onModalClose: () => {},
        });

        setTimeout(() => {
          setShowSuccessModal({ open: false });
          navigate(PATHS.VIEW_ROUTES);
        }, 2000);
      }
    });
  }

  const tableColumns = useMemo(
    ()=> Object.values(ALERT_VEHICLE_TABLE_HEADERS).map((header)=>{
      return {
        Header: header.nm,
        accessor: header.key,
        disableSortBy: !header.sorting,
        Cell:(row) => {
          if (row.column.id === "hwtyp") {
            let devName = DEVICE_HWTYP_VALUES[row.value || 1];
            return (
              <span className="geo-fence-cell">
                {devName ? devName : "-"}
              </span>
            )
          }

          return <span className="geo-fence-cell">
            {row.value}
          </span>
        }
      }
    })
  ,[])

  const handleRowSelect = (_, selected) => {
    if (selected && selected.length) {
      selectedVids.current = selected.map(selection => selection.original.idx);
    }
  }

  const handleNext = () => {
    if (!selectedVids.current || !selectedVids.current.length) {
      setError("You must select at least one vehicle to conitnue");
    } else {
      let filtereGeofences = [];
      geofences.forEach(fence => {
        let vid = fence.vehIdArr.find(id => selectedVids.current.includes(id));
        if (vid) {
          filtereGeofences.push(fence);
        }
      });

      setGeofences(filtereGeofences);
      setShowGeofences(true);
      setError("");
    }
  }

  return (
    <section className="panel-main set-route">
      <div>
        <Breadcrumb paths={breadcrumbPaths} />
      </div>
      {showGeofences ? <div className="set-route-container">
        <Input value={routeTitle} onChange={(event) => {setRouteTitle(event.target.value); setError("");}} placeholder="Enter Route Title" className="route-name" />
        <div className={`route-sequence-box ${(geofenceSeq && geofenceSeq.length) ? "" : "centeralize-text"}`}>
          {geofenceSeq && geofenceSeq.length ? geofenceSeq.map((fence, idx) => renderGeofenceCard(fence, "is-selected", fence.idx === geofenceSeq[geofenceSeq.length - 1].idx, idx + 1)) : <p>Click on the geofences below to create a route by sequencing geofences</p>}
        </div>
        <div className="save-route-btn-box">
          <p className={`${error ? "err-msg" : "info-msg"}`}>{!error && geofenceSeq && geofenceSeq.length >= 2 ? `Your selected route starts from ${geofenceSeq[0].title} and ends at ${geofenceSeq[geofenceSeq.length - 1].title}` : (error || "")}</p>
          <div>
            <Button onClick={() => setShowGeofences(false)} className="save-route-btn change-vehicle">
              Change Vehicles
            </Button>
            <Button onClick={handleSaveRoute} className="save-route-btn">Save Route</Button>
          </div>
        </div>

        <div className="geofence-selection-list">
          {geofences && geofences.length ? geofences.map(fence => renderGeofenceCard(fence)) : <p className="empty-geofence-list">{geofenceSeq && geofenceSeq.length ? "All geofences have been selected for this route" : "No geofence available for this vehicle"}</p>}
        </div>
      </div>
        :
      <div className="set-route-select-vehicle">
        <ReactTable
          columns={tableColumns}
          showSearch={true}
          heading={"Select Vehicles"}
          data={userVehicles || []}
          pageSize={10}
          showSelection={true}
          showSelectAll={true}
          checkboxLabel={"Select All"}
          onRowSelect={handleRowSelect}
          selectedRows={selectedVids.current}
        />
        <div className="save-route-btn-box">
          <p className={`${error ? "err-msg" : ""}`}>{error || ""}</p>
          <Button onClick={handleNext} className="save-route-btn next-btn">Next</Button>
        </div>
      </div>}

      <CustomPopUpModal { ...showSuccessModal } />
    </section>
  )
}

export default SetRoutes
